const Panel = () => import('@/views/panel/Panel.vue');

const Profile = () => import('@/views/auth/Profile.vue');

const Home = () => import('@/views/panel/Home.vue');

const Companies = () => import('@/views/panel/company/Companies.vue');
const FinancialYears = () => import('@/views/panel/company/FinancialYears.vue');

const NotificationsList = () => import('@/views/panel/user/NotificationsList');
const NotificationForm = () => import('@/views/panel/user/NotificationForm');

const CommentModerationList = () => import('@/views/panel/comment/CommentModerationList');

const Users = () => import('@/views/panel/user/Users');
const AdminManagement = () => import('@/views/panel/user/AdminManagement');
const AuditLogList = () => import('@/views/panel/auditLog/AuditLogList');
const UserInvitations = () => import('@/views/panel/user/UserInvitations');
const Roles = () => import('@/views/panel/role/Roles');
const Cities = () => import('@/views/panel/city/Cities');

const Accounts = () => import('../views/panel/account/Accounts.vue');
const FloatAccounts = () => import('../views/panel/account/FloatAccounts.vue');
const FloatAccountGroups = () => import('../views/panel/account/FloatAccountGroups.vue');
const AccountsTree = () => import('@/views/panel/account/AccountsTree.vue');

const DefaultAccounts = () => import('@/views/panel/defaultAccounts/DefaultAccounts.vue');

const Wares = () => import('@/views/panel/ware/Wares.vue');
const WaresTree = () => import('@/views/panel/ware/WaresTree.vue');

const Warehouses = () => import('@/views/panel/ware/Warehouses.vue');
const InventoryClerk = () => import('@/views/panel/ware/InventoryClerk.vue');
const Units = () => import('@/views/panel/ware/Units.vue');
const SalePriceTypes = () => import('@/views/panel/ware/SalePriceTypes.vue');

const Sanad = () => import('@/views/panel/sanad/Sanad.vue');
const SanadForm = () => import('@/views/panel/sanad/Form.vue');

const Transaction = () => import('@/views/panel/transaction/Transaction.vue');
const TransactionForm = () => import('@/views/panel/transaction/Form.vue');
const BankingOperations = () => import('@/views/panel/transaction/BankingOperations.vue');

const Factor = () => import('@/views/panel/factor/Factor.vue');
const FactorForm = () => import('@/views/panel/factor/Form.vue');
const FactorExpenses = () => import('@/views/panel/factor/Expenses.vue');

const FactorsAggregatedSanadForm = () => import('@/views/panel/factorsAggregatedSanad/Form');

const TransferForm = () => import('@/views/panel/transfer/Form.vue');

const AdjustmentForm = () => import('@/views/panel/adjustment/Form.vue');

const WarehouseHandlingForm = () => import('@/views/panel/warehouseHandling/Form.vue');

const ChequebookForm = () => import('../views/panel/chequebook/ChequebookForm.vue');

const Cheque = () => import('@/views/panel/cheque/Cheque.vue');
const ChequeDetail = () => import('../views/panel/cheque/ChequeDetail.vue');
const ChequeForm = () => import('../views/panel/cheque/ChequeForm.vue');

const ExportVerifiers = () => import('@/views/panel/exportVerifiers/ExportVerifiers.vue');

const Closing = () => import('../views/panel/closing/Closing.vue');

const ImprestSettlementForm = () => import('@/views/panel/imprest/ImprestSettlementForm');
const ImprestLedger = () => import('@/views/panel/imprest/ImprestLedger');
const ImprestBalance = () => import('@/views/panel/imprest/ImprestBalance');

const DefaultTexts = () => import('@/views/panel/defaultTexts/DefaultTexts');

const BasicInformationHome = () => import("@/views/modulePages/basicInformation/BasicInformationHome");

const AccountingHome = () => import("@/views/modulePages/accountingModule/AccountingHome");

const TreasuryHome = () => import("@/views/modulePages/treasuryModule/TreasuryHome");

const CommerceHome = () => import("@/views/modulePages/commerceModule/CommerceHome");

const WareHouseHome = () => import("@/views/modulePages/wareHouseModule/WareHouseHome");

const ReportHome = () => import("@/views/modulePages/reportModule/ReportHome");


const Plans = () => import('@/views/panel/subscription/Plans');

const SubscriptionFactorFrom = () => import('@/views/panel/subscription/SubscriptionFactorForm');
const SubscriptionFactorsList = () => import('@/views/panel/subscription/SubscriptionFactorsList');
const UserTurnover = () => import('@/views/panel/subscription/UserTurnover');
const Wallet = () => import('@/views/panel/subscription/Wallet');
const FactorDetail = () => import("@/views/panel/subscription/FactorDetail");


const TransactionFailed = () => import("@/views/panel/subscription/TransactionFailed");
const UserInvitationsTab = () => import("@/views/panel/user/UserInvitationsTab");
const Wizards = () => import("@/views/panel/wizard/Wizards");
const BalanceSheet = () => import("@/views/panel/balanceSheet/BalanceSheet");
const ConfigForm = () => import("@/views/panel/config/ConfigForm");
const Currency = () => import("@/views/main/currency/Currency");
const StoreForm = () => import("@/views/main/store/StoreForm");
const Supplier = () => import("@/views/main/supplier/Supplier");
const Business = () => import("@/views/main/business/Business");
const Brand = () => import("@/views/product/brand/Brand");
const Avail = () => import("@/views/product/avail/Avail");
const ProductProperty = () => import("@/views/product/productProperty/ProductProperty");
const Category = () => import("@/views/product/category/Category");
const ProductList = () => import("@/views/product/product/ProductList");
const ProductForm = () => import("@/views/product/product/ProductForm");
const EntrancePackageForm = () => import("@/views/entrance/entrance_package/EntrancePackageForm");
const EntracePackage = () => import("@/views/entrance/entrance_package/EntracePackage");
const StoreReceipt = () => import("@/views/entrance/store_receipt/StoreReceipt");
const EntrancePackageForStoreKeeper = () => import("@/views/entrance/entrance_package/EntrancePackageForStoreKeeper");
const SupplierEntrancePackageRemain = () => import("@/views/entrance/entrance_package/SupplierEntrancePackageRemain");
const SupplierStoreReceipts = () => import("@/views/entrance/store_receipt/SupplierStoreReceipts");
const ProductStoreReceipts = () => import("@/views/product/product/ProductStoreReceipts");
const NoContentProducts = () => import("@/views/product/product/NoContentProducts");
const ProductContentDevelopment = () => import("@/views/product/product/ProductContentDevelopment");
const TestAffiliate = () => import("@/views/main/TestAffiliate");
const BusinessOrdersReport = () => import("@/views/affiliate/BusinessOrdersReport");
const BusinessNotPaidOrders = () => import("@/views/affiliate/BusinessNotPaidOrders");
const AffiliateBusiness = () => import("@/views/affiliate/AffiliateBusiness");
const SelectAffiliateProductsForSale = () => import("@/views/affiliate/SelectAffiliateProductsForSale");
const AffiliateCustomers = () => import("@/views/affiliate/AffiliateCustomers");
const BusinessPaidOrders = () => import("@/views/affiliate/businessPaidOrders");
const OrderPackageWithoutAdmin = () => import("@/views/packing/OrderPackageWithoutAdmin");
const WaitingForPackingOrders = () => import("@/views/packing/WaitingForPackingOrders");
const WaitingForShippingOrders = () => import("@/views/packing/WaitingForShippingOrders");
const AdminPackingReport = () => import("@/views/packing/AdminPackingReport");
const OrderPackage = () => import("@/views/packing/OrderPackage");
const PackerWorkspace = () => import('@/modules/online_packing/PackerWorkspace.vue');
const KeeperWorkspace = () => import('@/modules/online_packing/KeeperWorkspace.vue');
const AffiliateAdminOrderPackages = () => import("@/views/packing/AffiliateAdminOrderPackages");
const BusinessAffiliateReport = () => import("@/views/affiliate/BusinessAffiliateReport");
const ShopHome = () => import("@/views/shop/ShopHome");
const ShopOrdersList = () => import("@/modules/order_admin/ShopOrdersList");
const ManualOrderCreate = () => import("@/modules/order_admin/ManualOrderCreate");
const AdminPaidOrders = () => import("@/modules/order_admin/AdminPaidOrders");
const ProcessingOrders = () => import("@/modules/order_admin/ProcessingOrders");
const PackedOrdersList = () => import("@/modules/order_admin/PackedOrdersList");
const ShippingCostReport = () => import('@/modules/order_admin/ShippingCostReport');
const RegisterTrackingCode = () => import("@/modules/order_admin/RegisterTrackingCode");
const ShippedOrdersList = () => import("@/modules/order_admin/ShippedOrdersList");
const AdminOrderDetail = () => import("@/modules/order_admin/AdminOrderDetail");
const SupportOrdersList = () => import("@/modules/order_admin/SupportOrdersList");
const AdminProductList = () => import("@/modules/product_admin/AdminProductList");
const MarketingProductList = () => import("@/modules/product_admin/MarketingProductList");
const BannerManagement = () => import("@/views/panel/marketing/BannerManagement");
const BeautyLandingBanners = () => import("@/views/panel/marketing/BeautyLandingBanners");
const ProductMarketingStats = () => import("@/modules/product_admin/ProductMarketingStats");
const DiscountCodes = () => import("@/views/panel/marketing/DiscountCodes");
const PackageBuilder = () => import("@/views/panel/marketing/PackageBuilder");
const CategorySeoSettings = () => import("@/views/panel/marketing/CategorySeoSettings");
const BrandSeoSettings = () => import("@/views/panel/marketing/BrandSeoSettings");
const AssistantConversations = () => import("@/views/panel/marketing/AssistantConversations");
const AdminProductForm = () => import("@/modules/product_admin/AdminProductForm");
const AdminVariationForm = () => import("@/modules/product_admin/AdminVariationForm");
const IssuesForm = () => import("@/modules/issues/IssuesForm");
const IssuesList = () => import("@/modules/issues/IssuesList");
const NoStoreHandleProducts = () => import("@/modules/store_handle/NoStoreHandleProducts");
const PackingStoreHandle = () => import("@/modules/store_handle/PackingStoreHandle");
const StoreHandleProducts = () => import("@/modules/store_handle/StoreHandleProducts");
const SoftwareDevelopmentProfit = () => import("@/modules/software_development/SoftwareDevelopmentProfit");
const HandlePostReport = () => import("@/modules/order_admin/HandlePostReport");
const AllStoreWaitForHandling = () => import("@/modules/store_handle/AllStoreWaitForHandling");
const AllStoreHandlingDone = () => import("@/modules/store_handle/AllStoreHandlingDone");
const ExtractedPostReportList = () => import("@/modules/order_admin/ExtractedPostReportList");
const ShirazProcessingOrders = () => import("@/modules/order_admin/ShirazProcessingOrders");
const InventoryTransfers = () => import("@/modules/store_handle/InventoryTransfers");
const PackingInventory = () => import("@/modules/store_handle/PackingInventory");
const StoreNoInfoProducts = () => import("@/modules/store_handle/StoreNoInfoProducts");
const PendingTransfers = () => import("@/modules/store_handle/PendingTransfers");
const ManagerEntrancePackageUpload = () => import("@/modules/enrtance/ManagerEntrancePackageUpload");
const ExtractedEntrancePackageList = () => import("@/modules/enrtance/ExtractedEntrancePackageList");
const EntrancePackageItemDetail = () => import("@/modules/enrtance/EntrancePackageItemDetail");
const ChinaPackingList = () => import("@/modules/enrtance/ChinaPackingList");
const ChinaPackingDetail = () => import("@/modules/enrtance/ChinaPackingDetail");
const PendingPackage = () => import("@/modules/delivery/PendingPackage");
const PendingPackageDetail = () => import("@/modules/delivery/PendingPackageDetail");
const DeliverPackage = () => import("@/modules/delivery/DeliverPackage");
const DeliverInsert = () => import("@/modules/delivery/DeliverInsert");
const Delivers = () => import("@/modules/delivery/Delivers");
const DomesticPriceChange = () => import("@/modules/product_admin/DomesticPriceChange");
const DomesticPriceChangeExcelUpdate = () => import("@/modules/product_admin/DomesticPriceChangeExcelUpdate");
const ToFixYoan = () => import("@/modules/report/ToFixYoan");
const ChinaPackageDeliveries = () => import("@/modules/delivery/ChinaPackageDeliveries");
const DeliverInsertedWaitForVerify = () => import("@/modules/delivery/DeliverInsertedWaitForVerify");
const NeedVerifyDeliver = () => import("@/modules/delivery/NeedVerifyDeliver");
const InventoryReportByBrand = () => import("@/modules/report/InventoryReportByBrand");
const InventoryReportByCurrency = () => import("@/modules/report/InventoryReportByCurrency");
const ProductStoreInventoryHistoryReport = () => import("@/modules/report/ProductStoreInventoryHistoryReport");
const SupplierLowInventoryByBrand = () => import("@/modules/store_handle/SupplierLowInventoryByBrand");
const ManagerDomesticEntrancePackageUpload = () => import("@/modules/enrtance/ManagerDomesticEntrancePackageUpload");
const DomesticPackageList = () => import("@/modules/enrtance/DomesticPackageList");
const DomesticPackingDetail = () => import("@/modules/enrtance/DomesticPackingDetail");
const PendingDomesticPackage = () => import("@/modules/delivery/PendingDomesticPackage");
const DeliverDomesticPackage = () => import("@/modules/delivery/DeliverDomesticPackage");
const DomesticPackageDeliveries = () => import("@/modules/delivery/DomesticPackageDeliveries");
const DomesticDeliverInsert = () => import("@/modules/delivery/DomesticDeliverInsert");
const PendingPackageDomesticDetail = () => import("@/modules/delivery/PendingPackageDomesticDetail");
const DomesticNeedVerifyDeliver = () => import("@/modules/delivery/DomesticNeedVerifyDeliver");
const DomesticDeliverInsertedWaitForVerify = () => import("@/modules/delivery/DomesticDeliverInsertedWaitForVerify");
const StoreToStoreTransfer = () => import("@/modules/store_handle/StoreToStoreTransfer");
const StoreToStoreTransferReport = () => import("@/modules/store_handle/StoreToStoreTransferReport");
const NoCurrencyProductsList = () => import("@/modules/product_admin/NoCurrencyProductsList");
const DeliveryCounting = () => import("@/modules/delivery/DeliveryCounting");
const ChinaDeliveryCounting = () => import("@/modules/delivery/ChinaDeliveryCounting");
const PackingUpload = () => import("@/modules/enrtance/PackingUpload");
const Packings = () => import("@/modules/enrtance/Packings");
const DeliverVerify = () => import("@/modules/delivery/DeliverVerify");
const SalesReports = () => import("@/modules/report/SalesReports");
const ExpensesDashboard = () => import("@/modules/expenses/ExpensesDashboard");
const NetProfitMonthly = () => import("@/modules/report/NetProfitMonthly");
const SiteSales = () => import("@/modules/report/SiteSales");
const PosSales = () => import("@/modules/report/PosSales");
const InventoryReport = () => import("@/modules/report/InventoryReport");
const AdminProductBulkCat = () => import("@/modules/product_admin/AdminProductBulkCat");
const AdminProductMerge = () => import("@/modules/product_admin/AdminProductMerge");
const AdminMergedProducts = () => import("@/modules/product_admin/AdminMergedProducts");
const NewAdminProductForm = () => import("@/modules/product_admin/NewAdminProductForm");
const AccountingDashboard = () => import("@/modules/AccountingDashboard");
const ChinaEntranceDashboard = () => import("@/modules/enrtance/ChinaEntranceDashboard");
const DomesticEntranceDashboard = () => import("@/modules/enrtance/DomesticEntranceDashboard");
const SupplierDashboard = () => import("@/modules/report/SupplierDashboard");
const PackingInfoProducts = () => import("@/modules/store_handle/PackingInfoProducts");
const PartnerManagement = () => import("@/modules/partner/PartnerManagement");
const PartnerDashboard = () => import("@/modules/partner/PartnerDashboard");
const AdminShirazPaidOrder = () => import("@/modules/order_admin/AdminShirazPaidOrder");
const PosDashboard = () => import("@/modules/pos/PosDashboard");
const PosNewDashboard = () => import("@/modules/pos/PosNewDashboard");
const ProductInventoryByBrandReport = () => import("@/modules/report/ProductInventoryByBrandReport");
const WalletTopUpFromOrder = () => import("@/finance/WalletTopUpFromOrder");
const PartnerProductList = () => import("@/modules/partner/PartnerProductList");
const PartnerPackingUpload = () => import("@/modules/partner/PartnerPackingUpload");
const PartnerExtractedEntrancePackageList = () => import("@/modules/partner/PartnerExtractedEntrancePackageList");
const InventoryExportSelector = () => import("@/modules/report/InventoryExportSelector");
const ProductLabelTable = () => import("@/modules/product_admin/ProductLabelTable");
const InventoryCurrencyMiniCard = () => import("@/modules/report/InventoryCurrencyMiniCard");
const PartnerProductForm = () => import("@/modules/partner/PartnerProductForm");
const PartnerShopOrderDetail = () => import("@/modules/partner/PartnerShopOrderDetail");
const PartnerShopOrdersList = () => import("@/modules/partner/PartnerShopOrdersList");
const PartnerInStoreOrdersList = () => import("@/modules/partner/PartnerInStoreOrdersList");
const PartnerCalculations = () => import("@/modules/partner/PartnerCalculations");
const PartnerCalculationsDaily = () => import("@/modules/partner/PartnerCalculationsDaily");
const PartnerCalculationsSettlement = () => import("@/modules/partner/PartnerCalculationsSettlement");
const PartnerCalculationsProductDetail = () => import("@/modules/partner/PartnerCalculationsProductDetail");
const PartnerCalculationsReturns = () => import("@/modules/partner/PartnerCalculationsReturns");
const PartnerCalculationsCostExposure = () => import("@/modules/partner/PartnerCalculationsCostExposure");
const AdminPartnerCalculationsProducts = () => import("@/modules/partner/AdminPartnerCalculationsProducts");
const AdminPartnerCalculationsProductDetailPage = () => import("@/modules/partner/AdminPartnerCalculationsProductDetailPage");
const AdminPartnerCalculationsDailyPage = () => import("@/modules/partner/AdminPartnerCalculationsDailyPage");
const AdminPartnerCalculationsSettlementPage = () => import("@/modules/partner/AdminPartnerCalculationsSettlementPage");
const AdminPartnerCalculationsReturnsPage = () => import("@/modules/partner/AdminPartnerCalculationsReturnsPage");
const AdminPartnerCalculationsCostExposurePage = () => import("@/modules/partner/AdminPartnerCalculationsCostExposurePage");
const AdminPartnerPackingDiscrepancy = () => import("@/modules/partner/AdminPartnerPackingDiscrepancy");
const AdminSalesReassignment = () => import("@/modules/partner/AdminSalesReassignment");
const partnerInStoreOrderDetail = () => import("@/modules/partner/PartnerInStoreOrderDetail");
const PartnerInStoreOrderDetail = () => import("@/modules/partner/PartnerInStoreOrderDetail");
const PartnerNewDashboard = () => import("@/modules/partner/PartnerNewDashboard");
const TreeManagement = () => import("@/components/scomponents/TreeManagement");
const AdminProductListLite = () => import("@/modules/product_admin/AdminProductListLite");
const WaitForDeliver = () => import("@/modules/delivery/WaitForDeliver");
const PriceSearch = () => import("@/modules/order_admin/PriceSearch");
const PartnerStockExitCreate = () => import("@/modules/partner/PartnerStockExitCreate");
const PartnerStockExitManager = () => import("@/modules/partner/PartnerStockExitManager");
const PartnerPaymentCreate = () => import("@/modules/partner/PartnerPaymentCreate");

export default [{
    name: 'Panel',
    path: '/panel',
    component: Panel,
    children: [
        {
            name: 'AppReleases',
            path: 'settings/app-releases',
            component: () => import('@/views/panel/settings/AppReleases.vue'),
        },
        {
            name: 'ShippingSettings',
            path: 'settings/shipping',
            component: () => import('@/views/panel/settings/ShippingSettings.vue'),
        },
        {
            name: 'OnlinePackerWorkspace',
            path: 'online-packing',
            component: PackerWorkspace,
            meta: { fullScreen: true, packingRole: 'paad' },
        },
        {
            name: 'OnlineKeeperWorkspace',
            path: 'online-packing-warehouse',
            component: KeeperWorkspace,
            meta: { fullScreen: true, packingRole: 'stke' },
        },
        {
            name: 'SupplierLowInventoryByBrand',
            path: 'supplierLowInventoryByBrand',
            component: SupplierLowInventoryByBrand
        },
        {
            name: 'ProductInventoryByBrandReport',
            path: 'productInventoryByBrandReport',
            component: ProductInventoryByBrandReport
        },
        {
            name: 'WalletTopUpFromOrder',
            path: 'walletTopUpFromOrder',
            component: WalletTopUpFromOrder
        },
        {
            name: 'ProductStoreInventoryHistoryReport',
            path: 'productStoreInventoryHistoryReport',
            component: ProductStoreInventoryHistoryReport
        },
        {
            name: 'PosDashboard',
            path: 'posDashboard',
            component: PosDashboard
        },
        {
            name: 'PosNewDashboard',
            path: 'posNewDashboard',
            component: PosNewDashboard
        },
        {
            name: 'Currency',
            path: 'currency',
            component: Currency
        },
        {
            name: 'ShopOrdersList',
            path: 'shopOrdersListTable',
            component: ShopOrdersList
        },
        {
            name: 'ManualOrderCreate',
            path: 'manualOrderCreate',
            component: ManualOrderCreate
        },
        {
            name: 'HandlePostReport',
            path: 'handlePostReport',
            component: HandlePostReport
        },
        {
            name: 'ExtractedPostReportList',
            path: 'extractedPostReportList',
            component: ExtractedPostReportList
        },
        {
            name: 'PaidShopOrderList',
            path: 'paidShopOrderList',
            component: AdminPaidOrders
        },
        {
            name: 'AdminShirazPaidOrders',
            path: 'adminShirazPaidOrders',
            component: AdminShirazPaidOrder
        },
        {
            name: 'InventoryTransfers',
            path: 'inventoryTransfers',
            component: InventoryTransfers
        },
        {
            name: 'PackingInventory',
            path: 'packingInventory',
            component: PackingInventory
        },
        {
            name: 'StoreNoInfoProducts',
            path: 'storeNoInfoProducts',
            component: StoreNoInfoProducts
        },
        {
            name: 'PendingTransfers',
            path: 'pendingTransfers',
            component: PendingTransfers
        },
        {
            name: 'InventoryExportSelector',
            path: 'inventoryExportSelector',
            component: InventoryExportSelector
        },
        {
            name: 'ManagerEntrancePackageUpload',
            path: 'managerEntrancePackageUpload',
            component: ManagerEntrancePackageUpload
        },
        {
            name: 'ManagerDomesticEntrancePackageUpload',
            path: 'managerDomesticEntrancePackageUpload',
            component: ManagerDomesticEntrancePackageUpload
        },
        {
            name: 'ExtractedEntrancePackageList',
            path: 'extractedEntrancePackageList',
            component: ExtractedEntrancePackageList
        },
        {
            name: 'PartnerExtractedEntrancePackageList',
            path: 'partnerExtractedEntrancePackageList',
            component: PartnerExtractedEntrancePackageList
        },
        {
            name: 'EntrancePackageItemDetail',
            path: 'entrancePackageItemDetail/:id?',
            component: EntrancePackageItemDetail,
            props: true
        },
        {
            name: 'ChinaPackingList',
            path: 'chinaPackingList',
            component: ChinaPackingList,
        },
        {
            name: 'DomesticPackageList',
            path: 'domesticPackageList',
            component: DomesticPackageList,
        },
        {
            name: 'ChinaPackingDetail',
            path: 'chinaPackingDetail/:id?',
            component: ChinaPackingDetail,
            props: true
        },
        {
            name: 'DomesticPackingDetail',
            path: 'domesticPackingDetail/:id?',
            component: DomesticPackingDetail,
            props: true
        },
        {
            name: 'DeliverInsertedWaitForVerify',
            path: 'deliverInsertedWaitForVerify/:id?',
            component: DeliverInsertedWaitForVerify,
            props: true
        },
        {
            name: 'DomesticDeliverInsertedWaitForVerify',
            path: 'domesticDeliverInsertedWaitForVerify/:id?',
            component: DomesticDeliverInsertedWaitForVerify,
            props: true
        },

        {
            name: 'PendingPackage',
            path: 'pendingPackage',
            component: PendingPackage,
        },
        {
            name: 'PendingDomesticPackage',
            path: 'pendingDomesticPackage',
            component: PendingDomesticPackage,
        },
        {
            name: 'ChinaPackageDeliveries',
            path: 'chinaPackageDeliveries',
            component: ChinaPackageDeliveries,
        },
        {
            name: 'DomesticPackageDeliveries',
            path: 'domesticPackageDeliveries',
            component: DomesticPackageDeliveries,
        },
        {
            name: 'NeedVerifyDeliver',
            path: 'needVerifyDeliver',
            component: NeedVerifyDeliver,
        },
        {
            name: 'DomesticNeedVerifyDeliver',
            path: 'domesticNeedVerifyDeliver',
            component: DomesticNeedVerifyDeliver,
        },
        {
            name: 'ToFixYoan',
            path: 'toFixYoan',
            component: ToFixYoan,
        },
        {
            name: 'InventoryReportByBrand',
            path: 'inventoryReportByBrand',
            component: InventoryReportByBrand,
        },
        {
            name: 'InventoryReportByCurrency',
            path: 'inventoryReportByCurrency',
            component: InventoryReportByCurrency,
        },
        {
            name: 'PendingPackageChinaDetail',
            path: 'pendingPackageChinaDetail/:id?',
            component: PendingPackageDetail,
            props: true
        },
        {
            name: 'PendingPackageDomesticDetail',
            path: 'pendingPackageDomesticDetail/:id?',
            component: PendingPackageDomesticDetail,
            props: true
        },
        {
            name: 'DeliverPackage',
            path: 'deliverPackage/:id?',
            component: DeliverPackage,
            props: true
        },
        {
            name: 'DeliverDomesticPackage',
            path: 'deliverDomesticPackage/:id?',
            component: DeliverDomesticPackage,
            props: true
        },
        {
            name: 'PackingUpload',
            path: 'packingUpload',
            component: PackingUpload,
        },
        {
            name: 'Packings',
            path: 'packings',
            component: Packings,
        },
        {
            name: 'CompletedPackings',
            path: 'completedPackings',
            component: Packings,
            props: { completed: true },
        },
        {
            name: 'DeliverVerify',
            path: 'deliverVerify',
            component: DeliverVerify,
        },
        {
            name: 'DeliverInsert',
            path: 'deliverInsert/:id?',
            component: DeliverInsert,
            props: true
        },
        {
            name: 'DomesticDeliverInsert',
            path: 'domesticDeliverInsert/:id?',
            component: DomesticDeliverInsert,
            props: true
        },
        {
            name: 'Delivers',
            path: 'delivers',
            component: Delivers,
        },

        {
            name: 'PackedOrdersList',
            path: 'packedOrdersList',
            component: PackedOrdersList
        },
        {
            name: 'ShippingCostReport',
            path: 'shippingCostReport',
            component: ShippingCostReport
        },
        {
            name: 'RegisterTrackingCode',
            path: 'registerTrackingCode',
            component: RegisterTrackingCode
        },
        {
            name: 'ShippedOrdersList',
            path: 'shippedOrdersList',
            component: ShippedOrdersList
        },
        {
            name: 'SupportOrdersList',
            path: 'supportOrdersList',
            component: SupportOrdersList
        },
        {
            name: 'DomesticPriceChange',
            path: 'domesticPriceChange',
            component: DomesticPriceChange
        },
        {
            name: 'DomesticPriceChangeExcelUpdate',
            path: 'domesticPriceChangeExcelUpdate',
            component: DomesticPriceChangeExcelUpdate
        },
        {
            name: 'ProcessingOrders',
            path: 'processingOrders',
            component: ProcessingOrders
        },
        {
            name: 'ProcessingShirazOrders',
            path: 'processingShirazOrders',
            component: ShirazProcessingOrders
        },
        {
            name: 'SoftwareDevelopmentProfit',
            path: 'softwareDevelopmentProfit',
            component: SoftwareDevelopmentProfit
        },
        {
            name: 'PartnerShopOrdersList',
            path: 'partnerShopOrdersList',
            component: PartnerShopOrdersList
        },
        {
            name: 'PartnerInStoreOrdersList',
            path: 'partnerInStoreOrdersList',
            component: PartnerInStoreOrdersList
        },
        {
            name: 'PartnerCalculations',
            path: 'partnerCalculations',
            component: PartnerCalculations
        },
        {
            name: 'PartnerCalculationsDaily',
            path: 'partnerCalculationsDaily',
            component: PartnerCalculationsDaily
        },
        {
            name: 'PartnerCalculationsSettlement',
            path: 'partnerCalculationsSettlement',
            component: PartnerCalculationsSettlement
        },
        {
            name: 'PartnerCalculationsProductDetail',
            path: 'partnerCalculations/product/:id',
            component: PartnerCalculationsProductDetail
        },
        {
            name: 'PartnerCalculationsReturns',
            path: 'partnerCalculationsReturns',
            component: PartnerCalculationsReturns
        },
        {
            name: 'PartnerCalculationsCostExposure',
            path: 'partnerCalculationsCostExposure',
            component: PartnerCalculationsCostExposure
        },
        {
            name: 'AdminPartnerCalculationsProducts',
            path: 'adminPartnerReports/products',
            component: AdminPartnerCalculationsProducts
        },
        {
            name: 'AdminPartnerPackingDiscrepancy',
            path: 'adminPartnerReports/packingDiscrepancy',
            component: AdminPartnerPackingDiscrepancy
        },
        {
            name: 'AdminPartnerCalculationsProductDetailPage',
            path: 'adminPartnerReports/products/:productId',
            component: AdminPartnerCalculationsProductDetailPage
        },
        {
            name: 'AdminPartnerCalculationsDailyPage',
            path: 'adminPartnerReports/daily',
            component: AdminPartnerCalculationsDailyPage
        },
        {
            name: 'AdminPartnerCalculationsSettlementPage',
            path: 'adminPartnerReports/settlement',
            component: AdminPartnerCalculationsSettlementPage
        },
        {
            name: 'AdminPartnerCalculationsReturnsPage',
            path: 'adminPartnerReports/returns',
            component: AdminPartnerCalculationsReturnsPage
        },
        {
            name: 'AdminPartnerCalculationsCostExposurePage',
            path: 'adminPartnerReports/costExposure',
            component: AdminPartnerCalculationsCostExposurePage
        },
        {
            name: 'AdminSalesReassignment',
            path: 'adminPartnerReports/salesReassignment',
            component: AdminSalesReassignment
        },
        {
            name: 'AdminProductListLite',
            path: 'adminProductListLite',
            component: AdminProductListLite
        },
        {
            name: 'WaitForDeliver',
            path: 'waitForDeliver',
            component: WaitForDeliver
        },

        {
            path: 'treeManage/:basePath?/:title?',
            name: 'TreeManagement',
            component: TreeManagement,
            props: true,
        },
        {
            name: 'PartnerNewDashboard',
            path: 'partnerNewDashboard',
            component: PartnerNewDashboard
        },
        {
            name: 'AdminOrderDetail',
            path: 'adminOrderDetail/:id?',
            component: AdminOrderDetail,
            props: true
        },
        {
            name: 'PartnerShopOrderDetail',
            path: 'partnerShopOrderDetail/:id?',
            component: PartnerShopOrderDetail,
            props: true
        },
        {
            name: 'PartnerInStoreOrderDetail',
            path: 'partnerInStoreOrderDetail/:id?',
            component: PartnerInStoreOrderDetail,
            props: true
        },

        {
            name: 'Store',
            path: 'store',
            component: StoreForm
        },
        {
            name: 'Supplier',
            path: 'supplier',
            component: Supplier
        },
        {
            name: 'Shop',
            path: 'shop',
            component: ShopHome
        },
        {
            name: 'EntrancePackage',
            path: 'inputEntrancePackage/:id?',
            component: EntracePackage,
            props: true
        },
        {
            name: 'SupplierEntrancePackageRemain',
            path: 'supplierEntrancePackageRemain/:id?',
            component: SupplierEntrancePackageRemain,
            props: true
        },
        {
            name: 'SupplierStoreReceipts',
            path: 'supplierStoreReceipts/:id?',
            component: SupplierStoreReceipts,
            props: true
        },
        {
            name: 'ProductStoreReceipts',
            path: 'productStoreReceipts/:id?',
            component: ProductStoreReceipts,
            props: true
        },
        {
            name: 'EntrancePackageForStoreKeeper',
            path: 'entrancePackageForStoreKeeper',
            component: EntrancePackageForStoreKeeper,
        },
        {
            name: 'StoreReceipt',
            path: 'storeReceipt/:id?',
            component: StoreReceipt,
            props: true
        },
        {
            name: 'AffiliateBusiness',
            path: 'affiliateBusiness/:id?',
            component: AffiliateBusiness,
            props: true
        },
        {
            name: 'AffiliateCustomers',
            path: 'affiliateCustomers',
            component: AffiliateCustomers,
        },
        {
            name: 'SalesReports',
            path: 'salesReports',
            component: SalesReports,
        },
        {
            name: 'NetProfitMonthly',
            path: 'netProfitMonthly',
            component: NetProfitMonthly,
        },
        {
            name: 'SiteSales',
            path: 'siteSales',
            component: SiteSales,
        },
        {
            name: 'PosSales',
            path: 'posSales',
            component: PosSales,
        },
        {
            name: 'InventoryReport',
            path: 'inventoryReport',
            component: InventoryReport,
        },
        {
            name: 'AdminProductBulkCat',
            path: 'adminProductBulkCat',
            component: AdminProductBulkCat,
        },
        {
            name: 'ExpensesDashboard',
            path: 'expensesDashboard',
            component: ExpensesDashboard,
        },
        {
            name: 'BusinessAffiliateReport',
            path: 'businessAffiliateReport',
            component: BusinessAffiliateReport,
        },
        {
            name: 'OrderPackageWithoutAdmin',
            path: 'orderPackageWithoutAdmin',
            component: OrderPackageWithoutAdmin,
        },
        {
            name: 'WaitingForPackingOrders',
            path: 'waitingForPackingOrders',
            component: WaitingForPackingOrders,
        },
        {
            name: 'WaitingForShippingOrders',
            path: 'waitingForShippingOrders',
            component: WaitingForShippingOrders,
        },
        {
            name: 'AdminPackingReport',
            path: 'adminPackingReport',
            component: AdminPackingReport,
        },
        {
            name: 'AffiliateAdminOrderPackages',
            path: 'affiliateAdminOrderPackages',
            component: AffiliateAdminOrderPackages,
        },
        {
            name: 'ProductLabelTable',
            path: 'productLabelTable',
            component: ProductLabelTable,
        },
        {
            name: 'InventoryCurrencyMiniCard',
            path: 'inventoryCurrencyMiniCard',
            component: InventoryCurrencyMiniCard,
        },
        {
            name: 'OrderPackage',
            path: 'orderPackage/:id?',
            component: OrderPackage,
            props: true
        },

        {
            name: 'AdminProductList',
            path: 'adminProductList',
            component: AdminProductList,
        },
        {
            name: 'AdminProductMerge',
            path: 'adminProductMerge',
            component: AdminProductMerge,
        },
        {
            name: 'AdminMergedProducts',
            path: 'adminMergedProducts',
            component: AdminMergedProducts,
        },
        {
            name: 'MarketingProductList',
            path: 'marketingProductList',
            component: MarketingProductList,
        },
        {
            name: 'BannerManagement',
            path: 'bannerManagement',
            component: BannerManagement,
        },
        {
            name: 'BeautyLandingBanners',
            path: 'beautyLandingBanners',
            component: BeautyLandingBanners,
        },
        {
            name: 'ProductMarketingStats',
            path: 'productMarketingStats',
            component: ProductMarketingStats,
        },
        {
            name: 'DiscountCodes',
            path: 'discountCodes',
            component: DiscountCodes,
        },
        {
            name: 'PackageBuilder',
            path: 'packageBuilder',
            component: PackageBuilder,
        },
        {
            name: 'CategorySeoSettings',
            path: 'categorySeoSettings',
            component: CategorySeoSettings,
        },
        {
            name: 'BrandSeoSettings',
            path: 'brandSeoSettings',
            component: BrandSeoSettings,
        },
        {
            name: 'AssistantConversations',
            path: 'assistantConversations',
            component: AssistantConversations,
        },
        {
            name: 'PartnerProductList',
            path: 'PartnerProductList',
            component: PartnerProductList,
        },
        {
            name: 'PartnerPackingUpload',
            path: 'partnerPackingUpload',
            component: PartnerPackingUpload,
        },
        {
            name: 'NoCurrencyProductsList',
            path: 'noCurrencyProductsList',
            component: NoCurrencyProductsList,
        },
        {
            name: 'DeliveryCounting',
            path: 'deliveryCounting/:packageId?',
            component: DeliveryCounting,
            props: true
        },
        {
            name: 'ChinaDeliveryCounting',
            path: 'chinaDeliveryCounting/:packageId?',
            component: ChinaDeliveryCounting,
            props: true
        },
        {
            name: 'ChinaEntranceDashboard',
            path: 'chinaEntranceDashboard/:packageId?',
            component: ChinaEntranceDashboard,
            props: true
        },
        {
            name: 'DomesticEntranceDashboard',
            path: 'domesticEntranceDashboard/:packageId?',
            component: DomesticEntranceDashboard,
            props: true
        },
        {
            name: 'SupplierDashboard',
            path: 'supplierDashboard/:supplierId?',
            component: SupplierDashboard,
            props: true
        },
        {
            name: 'AdminProductForm',
            path: 'adminProductForm/:id?',
            component: NewAdminProductForm,
            props: true
        },
        {
            name: 'PartnerProductForm',
            path: 'partnerProductForm/:id?',
            component: PartnerProductForm,
            props: true
        },
        {
            name: 'AdminVariationForm',
            path: 'adminVariationForm/:id?',
            component: AdminVariationForm,
            props: true
        },
        {
            name: 'IssuesForm',
            path: 'issuesForm',
            component: IssuesForm,
        },
        {
            name: 'OwnIssuesList',
            path: 'ownIssuesList',
            component: IssuesList,
        },
        {
            name: 'NoStoreHandleProducts',
            path: 'noStoreHandle',
            component: NoStoreHandleProducts,
        },
        {
            name: 'PackingInfoProducts',
            path: 'packingInfoProducts',
            component: PackingInfoProducts,
        },
        {
            name: 'PartnerManagement',
            path: 'partnerManagement',
            component: PartnerManagement,
        },
        {
            name: 'PartnerDashboard',
            path: 'partnerDashboard',
            component: PartnerDashboard,
        },
        {
            name: 'StoreHandleProducts',
            path: 'packingStoreHandle',
            component: StoreHandleProducts,
        },
        {
            name: 'AllStoreWaitForHandling',
            path: 'allStoreWaitForHandling',
            component: AllStoreWaitForHandling,
        },
        {
            name: 'AllStoreHandlingDone',
            path: 'allStoreHandlingDone',
            component: AllStoreHandlingDone,
        },
        {
            name: 'AccountingDashboard',
            path: 'accountingDashboard',
            component: AccountingDashboard,
        },
        {
            name: 'storeHandle',
            path: 'storeHandle/:productId?',
            component: PackingStoreHandle,
            props: true
        },

        {
            name: 'BusinessPaidOrders',
            path: 'businessPaidOrders',
            component: BusinessPaidOrders,
        },
        {
            name: 'Business',
            path: 'business',
            component: Business
        },
        {
            name: 'Brand',
            path: 'brand',
            component: Brand
        },
        {
            name: 'Avail',
            path: 'avail',
            component: Avail
        },
        {
            name: 'ProductProperty',
            path: 'productProperty',
            component: ProductProperty
        },
        {
            name: 'Category',
            path: 'category',
            component: Category
        },
        {
            name: 'ProductList',
            path: 'productList',
            component: ProductList
        },
        {
            name: 'ProductForm',
            path: 'productForm',
            component: ProductForm
        },
        {
            name: 'NoContentProductList',
            path: 'noContentProductList',
            component: NoContentProducts
        },
        {
            name: 'ProductContentDevelopment',
            path: 'productContentDevelopment',
            component: ProductContentDevelopment,
            props: true,
            children: [
                {
                    name: 'ProductContentDevelopmentDetail',
                    path: ':id',
                    component: ProductContentDevelopment,
                },
            ]
        },
        {
            name: 'BusinessOrdersReport',
            path: 'businessOrdersReport',
            component: BusinessOrdersReport
        },
        {
            name: 'BusinessNotPaidOrders',
            path: 'businessNotPaidOrders',
            component: BusinessNotPaidOrders
        },

        {
            name: 'Profile',
            path: 'profile',
            component: Profile,
        },
        {
            name: 'Home',
            path: 'home',
            component: Home,
        },
        {
            name: 'NotificationForm',
            path: 'notificationForm/:type',
            component: NotificationForm,
            props: true,
        },
        {
            name: 'NotificationsList',
            path: 'notificationsList',
            component: NotificationsList,
        },
        {
            name: 'CommentModeration',
            path: 'commentModeration',
            component: CommentModerationList,
        },
        {
            name: 'Users',
            path: 'users/:id?',
            component: Users,
        },
        {
            name: 'AdminManagement',
            path: 'admin-management',
            component: AdminManagement,
            meta: { managerOnly: true },
        },
        {
            name: 'AuditLogList',
            path: 'audit-log',
            component: AuditLogList,
            meta: { managerOnly: true },
        },
        {
            name: 'UserInvitations',
            path: 'userInvitations',
            component: UserInvitationsTab,
        },
        {
            name: 'Roles',
            path: 'roles',
            component: Roles,
        },
        {
            name: 'Cities',
            path: 'cities',
            component: Cities,
        }, {
            name: 'Companies',
            path: 'companies',
            component: Companies,
        },
        {
            name: 'FinancialYears',
            path: 'financialYears',
            component: FinancialYears,
        },
        {
            name: 'AccountsTree',
            path: 'accounts/tree',
            component: AccountsTree,
        },
        {
            name: 'Accounts',
            path: 'accounts/:level/:accountType?',
            component: Accounts,
            props: true
        },
        {
            name: 'FloatAccountGroups',
            path: 'floatAccountGroups/:is_cost_center?',
            component: FloatAccountGroups,
            props: true
        },
        {
            name: 'FloatAccounts',
            path: 'floatAccounts/:is_cost_center?',
            component: FloatAccounts,
            props: true
        },
        {
            name: 'WaresTree',
            path: 'wares/tree',
            component: WaresTree,
        },
        {
            name: 'Wares',
            path: 'wares/:level',
            component: Wares,
            props: true
        },
        {
            name: 'Services',
            path: 'services/:level',
            component: Wares,
            props: (route) => {
                return {
                    ...route.params,
                    isService: true
                }
            }
        },
        {
            name: 'Warehouses',
            path: 'warehouses',
            component: Warehouses
        },
        {
            name: 'InventoryClerk',
            path: 'inventoryClerk',
            component: InventoryClerk
        },
        {
            name: 'Units',
            path: 'units',
            component: Units
        },
        {
            name: 'TestAffiliate',
            path: 'TestAffiliate',
            component: TestAffiliate
        },
        {
            name: 'SelectAffiliateProductsForSale',
            path: 'selectAffiliateProductsForSale',
            component: SelectAffiliateProductsForSale
        },
        {
            name: 'SalePriceTypes',
            path: 'salePriceTypes',
            component: SalePriceTypes
        },
        {
            name: 'DefaultAccounts',
            path: 'defaultAccounts/:usage',
            component: DefaultAccounts,
            props: true
        },
        {
            name: 'Transaction',
            path: 'transaction',
            component: Transaction,
            children: [{
                name: 'BankingOperations',
                path: 'bankingOperations',
                component: BankingOperations,
            },
                {
                    name: 'TransactionForm',
                    path: ':type/:id?',
                    component: TransactionForm,
                    props: (route) => {
                        return {
                            accountId: route.query.accountId,
                            ...route.params,
                        };
                    },
                },
            ]
        },
        {
            name: 'ImprestSettlementForm',
            path: 'imprestSettlement/:id?',
            props: true,
            component: ImprestSettlementForm,
        },
        {
            name: 'ImprestLedger',
            path: 'imprest/ledger',
            component: ImprestLedger,
        },
        {
            name: 'ImprestBalance',
            path: 'imprest/balance',
            component: ImprestBalance,
        },
        {
            name: 'Sanad',
            path: 'sanad',
            component: Sanad,
            children: [{
                name: 'SanadForm',
                path: 'form/:id?',
                props: true,
                component: SanadForm,
            }]
        },
        {
            name: 'Factor',
            path: 'factor',
            component: Factor,
            children: [{
                name: 'FactorForm',
                path: 'form/:isPreFactor/:type/:id?',
                component: FactorForm,
                props: (route) => {
                    let isPreFactor = [true, 'true'].includes(route.params.isPreFactor)
                    return {
                        ...route.query,
                        ...route.params,
                        isPreFactor: isPreFactor
                    }
                }
            },
                {
                    name: 'FactorExpenses',
                    path: 'expenses/:factorType',
                    props: true,
                    component: FactorExpenses
                },
                {
                    name: 'FactorsAggregatedSanadForm',
                    path: 'aggregatedSanadForm/:type/:id?',
                    props: true,
                    component: FactorsAggregatedSanadForm
                },
            ]
        },
        {
            name: 'TransferForm',
            path: 'transfer/form/:id?',
            component: TransferForm,
            props: true,
        },
        {
            name: 'StoreToStoreTransfer',
            path: 'storeToStoreTransfer',
            component: StoreToStoreTransfer,
        },
        {
            name: 'StoreToStoreTransferReport',
            path: 'storeToStoreTransferReport',
            component: StoreToStoreTransferReport,
        },
        {
            name: 'AdjustmentForm',
            path: 'adjustment/form/:type/:id?',
            component: AdjustmentForm,
            props: true,
        },
        {
            name: 'WarehouseHandlingForm',
            path: 'warehouseHandling/form/:id?',
            component: WarehouseHandlingForm,
            props: true,
        },
        {
            name: 'Cheque',
            path: 'cheque',
            component: Cheque,
            children: [{
                name: 'ChequeDetail',
                path: ':id/detail',
                component: ChequeDetail,
                props: true,
            },
                {
                    name: 'ChequeForm',
                    path: 'form/:type/:isPaid/:id?',
                    component: ChequeForm,
                    props: (route) => {
                        return {
                            ...route.params,
                            isPaid: [true, 'true'].includes(route.params.isPaid)
                        }
                    },
                },
            ]
        },
        {
            name: 'ChequebookForm',
            path: 'chequebooks/:id?',
            component: ChequebookForm,
            props: true,
        },

        {
            name: 'ExportVerifiers',
            path: 'exportVerifiers',
            component: ExportVerifiers,
        },

        {
            name: 'Closing',
            path: 'closing',
            component: Closing,
        },

        {
            name: 'DefaultTexts',
            path: 'defaultTexts/:usage',
            component: DefaultTexts,
            props: true
        },
        {
            name: 'BasicInformation',
            path: 'basicInformation',
            component: BasicInformationHome,
        },
        {
            name: 'AccountingHome',
            path: 'accounting',
            component: AccountingHome,
        },

        {
            name: 'TreasuryHome',
            path: 'treasury',
            component: TreasuryHome,
        },

        {
            name: 'CommerceHome',
            path: 'commerce',
            component: CommerceHome,
        },

        {
            name: 'WareHouseHome',
            path: 'warehouseHome',
            component: WareHouseHome,
        },

        {
            name: 'ReportHome',
            path: 'reportHome',
            component: ReportHome,
        },


        {
            name: 'Plans',
            path: 'plans',
            component: Plans
        },
        {
            name: 'ExtendPlan',
            path: 'plans/extend',
            component: Plans,
            props: (route) => {
                return {
                    extend: true
                }
            }
        },
        {
            name: 'AddUser',
            path: 'plans/addUser',
            component: Plans,
            props: (route) => {
                return {
                    addUser: true
                }
            }
        },
        {
            name: 'SubscriptionFactorForm',
            path: 'subscriptionFactorForm/:id',
            component: SubscriptionFactorFrom,
            props: true
        },
        {
            name: 'SubscriptionFactorDetail',
            path: 'subscriptionFactorDetail/:id',
            component: FactorDetail,
            props: true
        },
        {
            name: 'SubscriptionFactorsList',
            path: 'subscriptionFactorsList',
            component: SubscriptionFactorsList
        },
        {
            name: 'UserTurnover',
            path: 'userTurnover',
            component: UserTurnover
        },
        {
            name: 'PartnerPaymentCreate',
            path: 'partnerPaymentCreate',
            component: PartnerPaymentCreate
        },
        {
            name: 'Wallet',
            path: 'wallet',
            component: Wallet
        },
        {
            name: 'PriceSearch',
            path: 'priceSearch',
            component: PriceSearch
        },
        {
            name: 'PartnerStockExitCreate',
            path: 'partnerStockExitCreate',
            component: PartnerStockExitCreate
        },
        {
            name: 'PartnerStockExitManager',
            path: 'partnerStockExitManager',
            component: PartnerStockExitManager
        },
        {
            name: 'TransactionFailed',
            path: 'transactionFailed',
            component: TransactionFailed
        },
        {
            name: 'Wizard',
            path: 'settingUps',
            component: Wizards
        },
        {
            name: 'ConfigForm',
            path: 'config/:module?',
            component: ConfigForm,
            props: true,
        },

    ]
}]
